/**
 * aramSceneBuilder — AR-01b
 * Single Responsibility: compose / dispose the Murder Bridge blockout group.
 *
 * Accepts THREE as a dependency parameter (testable without WebGL).
 *
 * Public API:
 *   buildAramSceneGroup(THREE) → { group: THREE.Group, dispose: () => void }
 *   ARAM_LANE_CONFIG — re-exported geometry constants
 */

import { Group } from 'three';
import {
  ARAM_LANE_CONFIG,
  buildVoid,
  buildBridge,
  buildSpawnPlatform,
  buildRails,
  buildAlcovePads
} from './aramBridgeMeshes.js';
import { buildVoidAtmosphere } from './aramVoidAtmosphere.js';

export { ARAM_LANE_CONFIG };

export function buildAramSceneGroup(THREE) {
  const GroupCls = THREE?.Group || Group;
  const group = new GroupCls();
  group.name = 'aram-scene';

  group.add(buildVoid(THREE));
  group.add(buildVoidAtmosphere(THREE));
  group.add(buildBridge(THREE));
  group.add(buildSpawnPlatform(THREE, 'blue'));
  group.add(buildSpawnPlatform(THREE, 'red'));
  buildRails(THREE).forEach(m => group.add(m));
  buildAlcovePads(THREE).forEach(m => group.add(m));

  function dispose() {
    while (group.children.length > 0) {
      group.remove(group.children[0]);
    }
  }

  return { group, dispose };
}
